import { render, staticRenderFns } from "./ads-filter.vue?vue&type=template&id=22e2bebf"
import script from "./ads-filter.vue?vue&type=script&lang=ts"
export * from "./ads-filter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports